<template>
  <div v-if="descriptionMap[status]" class="kyc-description">
    <div class="kyc-banner">
      <div class="message">
        {{ $t(descriptionMap[status].message) }}
        <a
          v-if="descriptionMap[status].linkHref"
          target="_blank"
          :href="descriptionMap[status].linkHref"
        >
          {{ $t(descriptionMap[status].link) }}
        </a>
      </div>

      <sb-button v-if="descriptionMap[status].CTA" :disabled="isCTADisabled" class="cta" size="medium" @click="CTAClicked">
        {{ $t(descriptionMap[status].CTA) }}
      </sb-button>
    </div>
  </div>
</template>
<script>

import KYCStatus from '@/enums/modules/setup/KYCStatus'
import messages from './KYC.messages'

export default {
  name: 'KYCDescription',
  props: {
    status: {
      type: Number,
      required: true
    },
    attempts: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      descriptionMap: {
        [KYCStatus.Created]: {
          type: '',
          message: 'Panel.Created.Message',
          link: 'Panel.Created.Link',
          linkHref: 'https://support.shipbob.com/s/article/Business-Information-Verification',
          CTA: 'Panel.Created.CTA'
        },
        [KYCStatus.Pending]: {
          type: 'warning',
          message: 'Panel.Pending.Message',
          CTA: 'Panel.Pending.CTA'
        },
        [KYCStatus.Completed]: {
          type: 'info',
          message: 'Panel.Completed.Message'
        },
        [KYCStatus.Expired]: {
          type: 'danger',
          message: 'Panel.Expired.Message',
          CTA: 'Panel.Expired.CTA'
        },
        [KYCStatus.Failed]: {
          type: 'danger',
          message: 'Panel.Failed.Message',
          link: 'Panel.Failed.Link',
          linkHref: 'https://support.shipbob.com/s/article/Business-Information-Verification'
        },
        [KYCStatus.NeedsReview]: {
          type: 'danger',
          message: 'Panel.NeedsReview.Message',
          CTA: 'Panel.NeedsReview.CTA'
        },
        [KYCStatus.Approved]: {
          type: 'success',
          message: 'Panel.Approved.Message'
        },
        [KYCStatus.Declined]: {
          type: 'danger',
          message: 'Panel.Declined.Message'
        }
      }
    }
  },
  computed: {
    isCTADisabled () {
      return this.status === KYCStatus.Expired && this.attempts > 3
    }
  },
  i18n: { messages },
  methods: {
    CTAClicked () {
      this.$emit('cta-clicked')
    }
  }
}

</script>


<style scoped lang='scss'>
.kyc-description {
  margin: 1em;

  .kyc-banner {
    margin: 0 0.5em;

    .cta {
      margin-top: 1em;
      font-weight: 500;
      line-height: 1em;
    }
  }
}
</style>
